"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const copilotApi_1 = require("@/schemaComponents/modules/copilotApi");
const bookParser_1 = require("@/utils/bookParser");
const fileToBook_1 = require("@/utils/fileToBook");
const function_client_1 = require("@/utils/function-client");
const react_split_1 = __importDefault(require("@uiw/react-split"));
const models_1 = require("app/models");
const models_hook_1 = require("app/models.hook");
const auth_1 = require("common/auth");
const spreadsheet_1 = require("common/spreadsheet");
const firestore_1 = require("comodel/firestore");
const firestore_web_1 = require("comodel/firestore-web");
const lodash_1 = require("lodash");
const papaparse_1 = require("papaparse");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const standard_1 = require("react-hook-schema/standard");
const components_1 = require("utils/components");
const ExcelPreview_1 = __importDefault(require("../new_item/ExcelPreview"));
const parseFile_1 = require("@/utils/parseFile");
const schemaComponents_1 = require("@/schemaComponents");
const getTranslationStatus = ({ uploadMode, isNew, currentStatus, }) => {
    switch (uploadMode) {
        case "reference":
            return "corrected";
        case "worksheet":
            if (isNew) {
                return null;
            }
            return currentStatus === "corrected" ? currentStatus : "updated";
        default:
            return null;
    }
};
function DataLink({ segmentId, projectId, onNext, onBack, uploadErrorList, setUploadErrorList, setCreatedSegmentIds, }) {
    var _a, _b;
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const [isCreating, setIsCreating] = (0, react_1.useState)(false);
    const [selectedCols, setSelectedCols] = (0, react_1.useState)([]);
    const [headerData, setHeaderData] = (0, react_1.useState)([]);
    const [preview, setPreview] = (0, react_1.useState)();
    const [warnings, setWarnings] = (0, react_1.useState)([]);
    // Frontend chunking progress state
    const [chunkProgress, setChunkProgress] = (0, react_1.useState)({
        isChunking: false,
        currentChunk: 0,
        totalChunks: 0,
        currentFile: 0,
        totalFiles: 0,
        phase: "processing",
    });
    const { data, loading: segmentDataLoading, set, isEditing, } = (0, models_hook_1.useSegmentDoc)({
        segmentId,
        projectId,
    });
    const { list: existingScriptList } = (0, models_hook_1.useReactiveScriptList)({
        projectId,
        segmentId,
    });
    const { list: langList } = (0, models_hook_1.useLangList)({ projectId });
    const langIds = (0, react_1.useMemo)(() => langList === null || langList === void 0 ? void 0 : langList.map((item) => item.langId), [langList]);
    const langAliases = (0, react_1.useMemo)(() => {
        return langList === null || langList === void 0 ? void 0 : langList.reduce((acc, item) => {
            acc[item.langId] = item.aliases || [];
            return acc;
        }, {});
    }, [langList]);
    const form = (0, react_hook_form_1.useFormContext)();
    const formData = form.watch();
    const toast = (0, standard_1.useToast)();
    const rawFiles = form.watch("rawFiles");
    // Utility function to chunk arrays
    function chunkArray(array, chunkSize) {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    }
    const uploadScriptsInChunks = (scripts, projectId, segmentId, fileIndex, totalFiles) => __awaiter(this, void 0, void 0, function* () {
        const CHUNK_SIZE = 100;
        const chunks = chunkArray(scripts, CHUNK_SIZE);
        setChunkProgress({
            isChunking: true,
            currentChunk: 0,
            totalChunks: chunks.length,
            currentFile: fileIndex + 1,
            totalFiles,
            phase: "uploading",
        });
        for (let i = 0; i < chunks.length; i++) {
            const chunk = chunks[i];
            setChunkProgress((prev) => (Object.assign(Object.assign({}, prev), { currentChunk: i + 1, phase: "uploading" })));
            try {
                yield (0, function_client_1.replaceSegmentSearchDocuments)({
                    projectId,
                    segmentId,
                    scripts: chunk,
                    endpoint: (0, copilotApi_1.getApiEndPoint)(),
                    isPartialUpload: true,
                    chunkIndex: i,
                    totalChunks: chunks.length,
                });
                if (i < chunks.length - 1) {
                    yield new Promise((resolve) => setTimeout(resolve, 200));
                }
            }
            catch (error) {
                console.error(`Error in chunk ${i + 1}/${chunks.length}:`, error);
                throw new Error(`アップロード中にエラーが発生しました (チャンク ${i + 1}/${chunks.length}): ${error.message}`);
            }
        }
        setChunkProgress((prev) => (Object.assign(Object.assign({}, prev), { phase: "completed" })));
    });
    const validateHeaderRowNumber = (index) => {
        // If no preview data yet, consider it valid (will be validated when preview loads)
        if (!preview || !preview[0] || !preview[0].records) {
            return true;
        }
        if (index && index > preview[0].records.length + 1) {
            // include the default header row
            setUploadErrorList([
                {
                    message: `指定された見出し行 (${index}行目) が存在しません。`,
                    fileName: rawFiles[0].fileName,
                },
            ]);
            return false;
        }
        else {
            // Clear any previous header row validation errors when validation passes
            const filteredErrors = uploadErrorList.filter((error) => { var _a; return !((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes("指定された見出し行")); });
            setUploadErrorList(filteredErrors);
        }
        return true;
    };
    const validateTranslationColumns = (rawFile) => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        if (!formData.translatedScriptFieldFormat ||
            !langList ||
            !langList.length) {
            return;
        }
        const book = yield (0, fileToBook_1.fileToBook)(rawFile);
        const headerRowIndex = formData.headerRowNumber !== undefined
            ? formData.headerRowNumber - 1
            : (_c = formData.ignoreLines) !== null && _c !== void 0 ? _c : 0;
        const actualColumns = ((_d = book.sheets[0].rows[headerRowIndex]) === null || _d === void 0 ? void 0 : _d.columns) || [];
        // Use KeyClassifier to properly detect translation columns (same logic as BookParser)
        const keyClassifier = new bookParser_1.KeyClassifier({
            originalScriptField: formData.originalScriptField,
            translatedScriptFieldFormat: formData.translatedScriptFieldFormat,
            langAliases: langAliases,
        });
        // Find all translation columns detected by KeyClassifier
        const detectedTranslationLangIds = new Set();
        actualColumns.forEach((column) => {
            const classification = keyClassifier.classify(column);
            if (classification.type === "translation") {
                detectedTranslationLangIds.add(classification.langId);
            }
        });
        // Check which languages are missing
        const missingLanguages = langList.filter((lang) => {
            return !detectedTranslationLangIds.has(lang.langId);
        });
        if (missingLanguages.length > 0) {
            const missingLangNames = missingLanguages.map((lang) => {
                const primaryColumn = formData.translatedScriptFieldFormat.replace("{locale}", lang.langId);
                return {
                    name: lang.langName || lang.langId,
                    column: primaryColumn,
                };
            });
            setWarnings([
                {
                    message: `以下の翻訳列が見つかりません: ${missingLangNames.map((m) => `${m.name} (${m.column})`).join(", ")}`,
                    fileName: rawFile.name,
                },
            ]);
        }
        else {
            setWarnings([]);
        }
    });
    // Validate automatically when file or format changes
    (0, react_1.useEffect)(() => {
        const validateFile = () => __awaiter(this, void 0, void 0, function* () {
            if (rawFiles && rawFiles.length > 0) {
                yield validateTranslationColumns(rawFiles[0].file);
            }
        });
        validateFile();
    }, [rawFiles, formData.translatedScriptFieldFormat, langList]);
    const handlePreview = () => __awaiter(this, void 0, void 0, function* () {
        // parse to records
        setUploadErrorList([]);
        const getPreview = (rawFile) => __awaiter(this, void 0, void 0, function* () {
            const bookParser = new bookParser_1.BookParser(Object.assign(Object.assign({}, formData), { langAliases, ignoreLines: formData.headerRowNumber !== undefined
                    ? formData.headerRowNumber - 1
                    : formData.ignoreLines !== undefined
                        ? formData.ignoreLines
                        : 0 }));
            const book = yield (0, fileToBook_1.fileToBook)(rawFile);
            const records = bookParser.parse(book);
            return {
                file: rawFile,
                fileName: rawFile.name,
                records: records.map((record) => {
                    var _a, _b;
                    const ret = {
                        ["ID"]: record.scriptId,
                        ["テキスト"]: record.text,
                    };
                    for (const lang of langList !== null && langList !== void 0 ? langList : []) {
                        ret[(_a = lang.langName) !== null && _a !== void 0 ? _a : lang.langId] =
                            ((_b = record.translations) === null || _b === void 0 ? void 0 : _b[lang.langId]) || "";
                    }
                    return ret;
                }),
            };
        });
        let previewRecords = [];
        if (rawFiles && rawFiles.length > 0) {
            try {
                previewRecords = yield Promise.all(rawFiles.map(({ file }) => getPreview(file)));
            }
            catch (e) {
                setUploadErrorList([
                    {
                        message: e.message || "予期せぬエラーが発生しました",
                        fileName: rawFiles[0].fileName,
                        e,
                    },
                ]);
                return false;
            }
        }
        setPreview(previewRecords);
    });
    // Save on initial render
    (0, react_1.useEffect)(() => {
        handlePreview();
    }, []);
    // Validate on scriptIdFormat change
    (0, react_1.useEffect)(() => {
        const scriptIdFormat = form.watch("scriptIdFormat");
        if (scriptIdFormat) {
            handlePreview();
        }
    }, [form.watch("scriptIdFormat")]);
    const onHeaderRowNumberSelect = (index, data) => {
        if (index) {
            validateHeaderRowNumber(index);
        }
        form.setValue("headerRowNumber", index);
        form.setValue("columnsToSaveOptional", selectedCols);
        setHeaderData(data !== null && data !== void 0 ? data : []);
    };
    const onAddScriptIdFormat = (value) => {
        if (typeof value !== "string" || !value)
            return;
        const currentFormat = formData.scriptIdFormat;
        const wrappedValue = `{${value}}`;
        // Only set the format if it doesn't already contain this value
        if (!currentFormat || !currentFormat.includes(wrappedValue)) {
            const newValue = !currentFormat
                ? wrappedValue
                : `${currentFormat}-${wrappedValue}`;
            form.setValue("scriptIdFormat", newValue);
            form.setValue("columnsToSaveOptional", selectedCols);
        }
    };
    const onChangeOriginalScriptField = (value) => {
        if (typeof value !== "string" || !value)
            return;
        form.setValue("originalScriptField", value);
        form.setValue("columnsToSaveOptional", selectedCols);
    };
    const handleBack = () => {
        onBack();
    };
    const handleNext = () => __awaiter(this, void 0, void 0, function* () {
        var _e, _f;
        // Only block if there are errors other than missing translation columns
        const hasBlockingErrors = uploadErrorList.some((error) => { var _a; return !((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes("以下の翻訳列が見つかりません")); });
        if (hasBlockingErrors)
            return;
        if (formData.headerRowNumber &&
            !validateHeaderRowNumber(formData.headerRowNumber)) {
            return;
        }
        const { rawFiles, multiFile, file, segmentName, rawFile } = formData, rest = __rest(formData, ["rawFiles", "multiFile", "file", "segmentName", "rawFile"]);
        const execute = (_g) => __awaiter(this, [_g], void 0, function* ({ rawFile, file, segmentName, }) {
            const _segmentId = formData.segmentId || (0, firestore_1.getUniqueId)();
            if (rawFile) {
                try {
                    // MEMO: UploadOption should be a class with a constructor for validation
                    const uploadOption = {
                        ignoreLines: formData.headerRowNumber !== undefined
                            ? formData.headerRowNumber - 1
                            : formData.ignoreLines !== undefined
                                ? formData.ignoreLines
                                : 0,
                        scriptIdFormat: formData.scriptIdFormat,
                        scriptTypeFormat: formData.scriptTypeFormat,
                        translatedScriptFieldFormat: formData.translatedScriptFieldFormat,
                        originalScriptField: formData.originalScriptField,
                        columnsToSave: formData.columnsToSave,
                        columnsToSaveOptional: formData.columnsToSaveOptional,
                        uploadMode: formData.uploadMode,
                        langAliases: langAliases,
                    };
                    const bookParser = new bookParser_1.BookParser(uploadOption);
                    const book = yield (() => __awaiter(this, void 0, void 0, function* () {
                        try {
                            if (rawFile &&
                                rawFile.type ===
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                return (0, spreadsheet_1.openXLSXBook)(yield (0, parseFile_1.readExcel)(rawFile));
                            }
                            else if (rawFile && rawFile.type === "text/csv") {
                                const text = yield (rawFile === null || rawFile === void 0 ? void 0 : rawFile.text());
                                return (0, spreadsheet_1.openCSVBook)((0, papaparse_1.parse)(text, {
                                    delimiter: ",",
                                    quoteChar: '"',
                                    skipEmptyLines: "greedy",
                                }).data);
                            }
                            else {
                                throw new Error("ファイルの形式が正しくないため保存に失敗しました。");
                            }
                        }
                        catch (e) {
                            throw new Error(e.message || "Invalid file type");
                        }
                    }))();
                    // Handle create records
                    const records = bookParser.parse(book);
                    if (!records || !langIds) {
                        throw new Error("レコードか翻訳言語が見つかりませんでした。");
                    }
                    let naiveScripts = [];
                    const isUpdating = !!segmentId;
                    if (isUpdating) {
                        const uploadedScriptIds = records.map((record) => record.scriptId);
                        // in case of editing
                        // if script is removed (nonexistent in the uploaded script), remove the row in the DB.
                        naiveScripts =
                            (existingScriptList === null || existingScriptList === void 0 ? void 0 : existingScriptList.filter((script) => uploadedScriptIds.includes(script.scriptId))) || [];
                        const existingScriptIds = naiveScripts === null || naiveScripts === void 0 ? void 0 : naiveScripts.map((script) => script.scriptId);
                        records.forEach((record) => {
                            const { scriptId, text, translations } = record;
                            // case 1: no matched id
                            if (!(existingScriptIds === null || existingScriptIds === void 0 ? void 0 : existingScriptIds.includes(scriptId))) {
                                naiveScripts.push(Object.assign(Object.assign({}, record), { translationStatus: langIds === null || langIds === void 0 ? void 0 : langIds.reduce((acc, langId) => {
                                        acc[langId] = (translations === null || translations === void 0 ? void 0 : translations[langId])
                                            ? getTranslationStatus({
                                                uploadMode: formData.uploadMode,
                                                isNew: true,
                                            })
                                            : null;
                                        return acc;
                                    }, {}) }));
                                return;
                            }
                            const existingScript = existingScriptList === null || existingScriptList === void 0 ? void 0 : existingScriptList.find((script) => script.scriptId === scriptId);
                            if (!existingScript)
                                return;
                            const isTextChanged = existingScript.text !== text;
                            // if the original text of uploaded row and the script differs
                            if (isTextChanged) {
                                // for each languages
                                for (const langId of langIds) {
                                    // 1. if translated text is present in the uploaded script,
                                    if (translations === null || translations === void 0 ? void 0 : translations[langId]) {
                                        // update the original text and translated text,
                                        // and update the status, also isTextUpdated set to true.
                                        naiveScripts = naiveScripts.map((script) => {
                                            var _a;
                                            return script.scriptId === existingScript.scriptId
                                                ? Object.assign(Object.assign({}, script), { text, translations: Object.assign(Object.assign({}, script.translations), { [langId]: translations[langId] }), translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: getTranslationStatus({
                                                            uploadMode: formData.uploadMode,
                                                            isNew: false,
                                                            currentStatus: (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId],
                                                        }) }), isTextUpdated: true }) : script;
                                        });
                                    }
                                    else {
                                        // 2. if translated text is empty
                                        // update the original text, and set the status to "更新" (null), also isTextUpdated to true
                                        naiveScripts = naiveScripts.map((script) => script.scriptId === existingScript.scriptId
                                            ? Object.assign(Object.assign({}, script), { text, translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: null }), isTextUpdated: true }) : script);
                                    }
                                }
                            }
                            else {
                                // if the original text of uploaded row and the script is same
                                // for each languages
                                langIds === null || langIds === void 0 ? void 0 : langIds.forEach((langId) => {
                                    // translation is empty, then do nothing
                                    if (!(translations === null || translations === void 0 ? void 0 : translations[langId]))
                                        return;
                                    // if translation is updated, then update the translation, and update the status
                                    naiveScripts = naiveScripts.map((script) => {
                                        var _a;
                                        return script.scriptId === existingScript.scriptId
                                            ? Object.assign(Object.assign({}, script), { translations: Object.assign(Object.assign({}, script.translations), { [langId]: translations[langId] }), translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: getTranslationStatus({
                                                        uploadMode: formData.uploadMode,
                                                        isNew: false,
                                                        currentStatus: (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId],
                                                    }) }) }) : script;
                                    });
                                });
                            }
                        });
                    }
                    else {
                        // in case of new
                        naiveScripts = records.map((record) => {
                            return Object.assign(Object.assign({}, record), { translationStatus: langIds === null || langIds === void 0 ? void 0 : langIds.reduce((acc, langId) => {
                                    var _a;
                                    acc[langId] = ((_a = record.translations) === null || _a === void 0 ? void 0 : _a[langId])
                                        ? getTranslationStatus({
                                            uploadMode: formData.uploadMode,
                                            isNew: true,
                                        })
                                        : null;
                                    return acc;
                                }, {}) });
                        });
                    }
                    const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId, segmentId: _segmentId }, {
                        filter: { segmentId: _segmentId },
                    });
                    const preparedScripts = accessor
                        .prepareUpload(naiveScripts)
                        .map((record) => (Object.assign({}, record.data)));
                    try {
                        // For execute function, we need to determine the file index
                        // This is a bit tricky since execute is called from different contexts
                        const fileIndex = rawFiles
                            ? rawFiles.findIndex((f) => f.fileName === segmentName)
                            : 0;
                        const totalFileCount = ((rawFiles === null || rawFiles === void 0 ? void 0 : rawFiles.length) || 0) + (file ? 1 : 0);
                        yield uploadScriptsInChunks(preparedScripts, projectId, _segmentId, fileIndex, totalFileCount);
                    }
                    catch (e) {
                        throw new Error(`${e.message || "サーバーで予期せぬエラーが発生したため保存できませんでした"}`);
                    }
                }
                catch (e) {
                    return {
                        success: false,
                        fileName: (rawFile === null || rawFile === void 0 ? void 0 : rawFile.name) || segmentName,
                        segmentId: _segmentId,
                        error: e.message ||
                            "ファイルのアップロード中にエラーが発生しました",
                    };
                }
            }
            try {
                yield set(Object.assign(Object.assign({}, rest), { segmentName,
                    file, segmentId: _segmentId, createdAt: rest.createdAt || Date.now() }));
            }
            catch (e) {
                throw new Error(`${e.message || "サーバーで予期せぬエラーが発生したため保存できませんでした"}`);
            }
            return {
                success: true,
                fileName: (rawFile === null || rawFile === void 0 ? void 0 : rawFile.name) || segmentName,
                segmentId: _segmentId,
            };
        });
        if (rawFiles.length === 0 && !file && !segmentName) {
            throw new Error("ファイルが選択されていません");
        }
        const totalFiles = ((rawFiles === null || rawFiles === void 0 ? void 0 : rawFiles.length) || 0) + (file ? 1 : 0);
        // Reset chunking progress
        setChunkProgress({
            isChunking: false,
            currentChunk: 0,
            totalChunks: 0,
            currentFile: 0,
            totalFiles,
            phase: "processing",
        });
        const uploadPromises = [];
        if (file) {
            const uploadPromise = execute({
                rawFile: rawFile,
                segmentName: segmentName || "",
                file: file,
            });
            uploadPromises.push(uploadPromise);
        }
        if (rawFiles && rawFiles.length > 0) {
            rawFiles.forEach(({ file, fileName }, index) => {
                var _a, _b;
                const uploadPromise = execute({
                    rawFile: file,
                    segmentName: fileName,
                    file: (_b = (_a = formData.multiFile) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : fileName,
                });
                uploadPromises.push(uploadPromise);
            });
        }
        try {
            setIsCreating(true);
            setUploadErrorList([]);
            setCreatedSegmentIds([]);
            const results = yield Promise.all(uploadPromises);
            const successfulUploads = results.filter((result) => !!(result === null || result === void 0 ? void 0 : result.success));
            const failedUploads = results.filter((result) => !(result === null || result === void 0 ? void 0 : result.success));
            if (successfulUploads.length > 0) {
                setCreatedSegmentIds(successfulUploads.map((upload) => upload.segmentId));
            }
            if (failedUploads.length > 0) {
                setUploadErrorList(failedUploads.map((upload) => ({
                    message: upload === null || upload === void 0 ? void 0 : upload.error,
                    fileName: (upload === null || upload === void 0 ? void 0 : upload.fileName) || "",
                })));
            }
            // Reset chunking progress on success
            setChunkProgress({
                isChunking: false,
                currentChunk: 0,
                totalChunks: 0,
                currentFile: 0,
                totalFiles: 0,
                phase: "completed",
            });
            if (successfulUploads.length > 0) {
                toast({
                    message: "アップロードが完了しました",
                    duration: 10000,
                    type: "success",
                });
            }
            if (failedUploads.length > 0) {
                toast({
                    message: "一部のファイルのアップロードに失敗しました",
                    duration: 10000,
                });
            }
            onNext({
                error: "",
            });
        }
        catch (error) {
            // Reset chunking progress on error
            setChunkProgress({
                isChunking: false,
                currentChunk: 0,
                totalChunks: 0,
                currentFile: 0,
                totalFiles: 0,
                phase: "processing",
            });
            let errorMessage = "アップロード中にエラーが発生しました";
            // Handle specific timeout errors
            if ((error === null || error === void 0 ? void 0 : error.code) === "deadline-exceeded" ||
                ((_e = error === null || error === void 0 ? void 0 : error.message) === null || _e === void 0 ? void 0 : _e.includes("timeout")) ||
                ((_f = error === null || error === void 0 ? void 0 : error.message) === null || _f === void 0 ? void 0 : _f.includes("処理時間が制限を超えました"))) {
                errorMessage =
                    "アップロード処理がタイムアウトしました。ファイルサイズが大きすぎる可能性があります。より小さなファイルに分割してアップロードしてください。";
            }
            else if ((error === null || error === void 0 ? void 0 : error.code) === "unauthenticated") {
                errorMessage =
                    "認証エラーが発生しました。再度ログインしてお試しください。";
            }
            else if ((error === null || error === void 0 ? void 0 : error.code) === "permission-denied") {
                errorMessage = "このプロジェクトに対する権限がありません。";
            }
            console.error("Upload error:", error);
            toast({
                message: errorMessage,
                duration: 1000, // Show longer for error messages
                type: "error",
            });
            setUploadErrorList([
                {
                    message: error.message || "予期せぬエラーが発生しました",
                    fileName: "全体のアップロード処理",
                },
            ]);
        }
        finally {
            setIsCreating(false);
        }
    });
    // Review  table
    const columns = Object.keys((_a = preview === null || preview === void 0 ? void 0 : preview[0].records[0]) !== null && _a !== void 0 ? _a : {}).map((key) => ({
        accessor: key || "",
        Header: key,
        Cell: ({ row }) => {
            return react_1.default.createElement("span", null, (0, lodash_1.get)(row.original, key));
        },
    }));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_bootstrap_1.Modal, { show: isCreating || chunkProgress.isChunking },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, null,
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, chunkProgress.isChunking ? "アップロード中" : "読み込み中です")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null, chunkProgress.isChunking ? (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "mb-3" },
                    react_1.default.createElement("div", { className: "progress" },
                        react_1.default.createElement("div", { className: "progress-bar", role: "progressbar", style: {
                                width: `${Math.round((chunkProgress.currentChunk / chunkProgress.totalChunks) * 100)}%`,
                            }, "aria-valuenow": Math.round((chunkProgress.currentChunk / chunkProgress.totalChunks) *
                                100), "aria-valuemin": 0, "aria-valuemax": 100 },
                            Math.round((chunkProgress.currentChunk / chunkProgress.totalChunks) *
                                100),
                            "%"))))) : (react_1.default.createElement("p", null, "\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044")))),
        (uploadErrorList.length > 0 || warnings.length > 0) && (react_1.default.createElement("div", { className: "text-danger text-center", style: { fontWeight: "bold", padding: "20px 0px" } },
            uploadErrorList.map((error, index) => {
                var _a;
                return (react_1.default.createElement("p", { key: `error-${index}` }, ((_a = error.e) === null || _a === void 0 ? void 0 : _a.render()) ||
                    error.message ||
                    `Error in file: ${error.fileName}`));
            }),
            warnings.map((warning, index) => (react_1.default.createElement("p", { key: `warning-${index}`, className: "text-warning" }, warning.message))))),
        react_1.default.createElement(react_split_1.default, { mode: "horizontal", lineBar: true, style: { display: "flex", height: "100%", gap: 6 } },
            react_1.default.createElement(components_1.Card, { style: { width: "50%", padding: "14px 10px" } },
                react_1.default.createElement(schemaComponents_1.Field, { control: form.control, schema: {
                        schemaType: "object",
                        properties: [
                            {
                                title: "見出し行",
                                stacked: true,
                                propertyName: "headerRowNumber",
                                tooltip: "アップロードされたファイルのうち、見出しにする行を指定します。たとえば、一番上 (1行目) を見出し行として扱う場合 1 を、3 行目を見出し行として扱う場合 3 を指定します。",
                                tooltipVariant: "hover",
                                schema: {
                                    schemaType: "number",
                                    required: false,
                                    uiType: "number",
                                    minValue: 1,
                                },
                            },
                            {
                                title: "Script ID の書式",
                                stacked: true,
                                propertyName: "scriptIdFormat",
                                tooltip: "Script ID の書式を {列名} を使って指定します (例: {id}_{row_no})。列名の他に、 {row_no} と {sheet_name} が使えます。",
                                schema: {
                                    schemaType: "text",
                                    required: false,
                                },
                            },
                            {
                                title: "翻訳前データの列名",
                                stacked: true,
                                propertyName: "originalScriptField",
                                tooltip: "翻訳前データの列名を指定します (例: text_ja)。",
                                schema: {
                                    schemaType: "selector",
                                    required: false,
                                    options: (headerData !== null && headerData !== void 0 ? headerData : [])
                                        .map((field) => ({
                                        value: field,
                                        title: field,
                                    }))
                                        .filter(({ title }) => !!title),
                                    checkStyle: true,
                                },
                            },
                            {
                                title: "翻訳済みデータの列書式",
                                stacked: true,
                                propertyName: "translatedScriptFieldFormat",
                                tooltip: "翻訳済みデータの列名の書式を {locale} を使って指定します (例: text{locale})。",
                                schema: {
                                    schemaType: "text",
                                    required: true,
                                    validators: [
                                        (value) => {
                                            const localeCount = (value.match(/{locale}/g) || [])
                                                .length;
                                            if (localeCount !== 1) {
                                                return "翻訳されたデータ列の形式には、{locale} を 1 回だけ含める必要があります。";
                                            }
                                            return true;
                                        },
                                    ],
                                },
                            },
                        ],
                    } }),
                react_1.default.createElement(components_1.Button, { style: { marginTop: 27 }, onClick: handlePreview }, "\u30D7\u30EC\u30D3\u30E5\u30FC\u306E\u66F4\u65B0")),
            react_1.default.createElement(components_1.Card, { style: { width: "50%", padding: "14px 29px 29px 27px" } },
                react_1.default.createElement("div", null, (rawFiles === null || rawFiles === void 0 ? void 0 : rawFiles[0]) ? (react_1.default.createElement(ExcelPreview_1.default, { data: form.watch(), file: rawFiles[0].file, onRowSelect: (rowIndex) => {
                        form.setValue("headerRowNumber", rowIndex);
                    }, onColumnSelect: (columnKeys) => {
                        setSelectedCols(columnKeys);
                    }, onHeaderRowNumberSelect: onHeaderRowNumberSelect, onAddScriptIdFormat: onAddScriptIdFormat, onChangeOriginalScriptField: onChangeOriginalScriptField })) : (react_1.default.createElement(components_1.Loading, null))))),
        react_1.default.createElement(components_1.Card, { style: { paddingBottom: 20, marginTop: 16 } },
            react_1.default.createElement(components_1.Table, { styles: {}, columns: columns, data: (_b = preview === null || preview === void 0 ? void 0 : preview[0].records) !== null && _b !== void 0 ? _b : [], pageSize: 5, title: "\u30D7\u30EC\u30D3\u30E5\u30FC", topPagination: false, paginationWrapperStyle: { padding: "0 20px" } })),
        react_1.default.createElement("div", { className: "d-flex justify-content-between mt-4" },
            react_1.default.createElement(components_1.Button, { variant: "outline-primary", size: "xl", onClick: handleBack }, "\u623B\u308B"),
            react_1.default.createElement(components_1.Button, { size: "xl", onClick: handleNext, disabled: !form.formState.isValid || uploadErrorList.length > 0 }, "\u6B21\u3078"))));
}
exports.default = DataLink;
